<template>
  <div class="hello">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索客户..."
        clearable
        icon="ios-search"
        @on-change="searchMaterial"
        style="width: 250px; margin-right: auto"
      >
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadMaterial"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="openCreateSalesRecordDrawer()"
        >新增销售记录</Button
      >
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      >
        <template slot-scope="{ row }" slot="content">
          <Poptip
            placement="bottom"
            word-wrap
            width="400"
            trigger="hover"
            :content="row.content"
          >
            <p class="content-item">{{ row.content }}</p>
          </Poptip>
        </template>
      </Table>
    </div>
    <CreateSalesRecordDrawer ref="CreateSalesRecordDrawer" />
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";
import CreateSalesRecordDrawer from "./CreateSalesRecordDrawer";
import _ from "lodash";

export default {
  name: "Material",
  components: { CreateSalesRecordDrawer },
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      columns: [
        {
          title: "行",
          key: "row",
          width: 60,
          align: "center",
          render: (h, params) =>
            h(
              "span",
              { style: { color: "darkgray" } },
              this.page * 15 + params.index + 1
            ),
        },
        {
          title: "客户",
          key: "model",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.CreateSalesRecordDrawer.openDrawer(params.row);
                    },
                  },
                },
                params.row.customer.name
              ),
            ]);
          },
        },
        {
          title: "内容",
          slot: "content",
          width: 600,
        },
        {
          title: "创建人",
          key: "createdBy",
          align: "center",
          render: (h, params) => {
            return h("div", params.row.createdBy.name);
          },
        },
        {
          title: "创建时间",
          key: "createdAt",
          render: (h, params) => {
            return h(
              "div",
              dayjs(params.row.createdAt).format("YYYY-MM-DD HH:mm")
            );
          },
        },
      ],
      tableHeight: 300,
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.salesRecord.salesRecordList,
      totalRows: (state) => state.salesRecord.totalCounts,
      customerList: (state) => state.customer.customerList,
    }),
  },
  methods: {
    ...mapActions({
      getSalesRecordList: "salesRecord/getSalesRecordListAction",
    }),
    openCreateSalesRecordDrawer() {
      this.$refs.CreateSalesRecordDrawer.openDrawer();
    },
    async loadMaterial(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15 };
      if (this.searchText) api.searchText = this.searchText;
      try {
        this.tableLoading = true;
        await this.getSalesRecordList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchMaterial: _.debounce(function () {
      this.page = 0;
      this.loadMaterial();
    }, 1000),
  },
  created() {
    this.loadMaterial();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)

.content-item
  width 600px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
</style>
